import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { Subject, interval } from 'rxjs';
import { takeUntil, flatMap } from 'rxjs/operators';

import { RossConfigService } from 'src/@ross/services/config.service';
import { RossNavigationService } from 'src/@ross/components/navigation/navigation.service';
import { RossSidebarService } from 'src/@ross/components/sidebar/sidebar.service';
import { navigation } from './navigation';
import { AuthenticationService } from '../core/services/auth.service';
import { NotificationService } from './notification/notification.service';
import { MenuStoreService } from '../core/services/menu-store.service';


@Component({
    selector   : 'pages',
    templateUrl: './pages.component.html',
    styleUrls  : ['./pages.component.scss']
})
export class PagesComponent implements OnInit, OnDestroy {
    currentUser: any;
    rossConfig: any;
    navigation: any;
    hidden = false;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        @Inject(DOCUMENT) private document: any,
        private _rossConfigService: RossConfigService,
        private _rossNavigationService: RossNavigationService,
        private _rossSidebarService: RossSidebarService,
        private authService: AuthenticationService,
        private _notificationService: NotificationService,
        private _menuStoreService: MenuStoreService,
        private _platform: Platform
    ) {
        this.currentUser = this.authService.currentUserValue;

        // Add is-mobile class to the body if the platform is mobile
        if ( this._platform.ANDROID || this._platform.IOS ) {
            this.document.body.classList.add('is-mobile');
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */

    ngOnInit(): void {
        // Subscribe to config changes
        this._rossConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                this.rossConfig = config;

                // Boxed
                if ( this.rossConfig.layout.width === 'boxed' ) {
                    this.document.body.classList.add('boxed');
                } else {
                    this.document.body.classList.remove('boxed');
                }

                // Color theme - Use normal for loop for IE11 compatibility
                for ( let i = 0; i < this.document.body.classList.length; i++ ) {
                    const className = this.document.body.classList[i];

                    if ( className.startsWith('theme-') ) {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.rossConfig.colorTheme);
            });

        // Get default navigation
        this._menuStoreService.menu$.subscribe(data => {

            if (data.length > 0) {
                // Register the navigation to the service
                this._rossNavigationService.register('main', data);

                // Set the main navigation as our current navigation
                this._rossNavigationService.setCurrentNavigation('main');
            }

        });

        /* this.updateNotification(); */

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._rossSidebarService.getSidebar(key).toggleOpen();
    }


    updateNotification() {
        interval(60000)
            .pipe(
                flatMap(() => this._notificationService.countUnRead()),
            )
            .subscribe((data: any) => {
                this._rossNavigationService.updateNavigationItem(['Notificaciones'], {
                    badge: {
                        title: data.COUNT_NOTIFICATIONS || 0,
                        bg: '#F44336',
                        fg: '#FFFFFF'
                    }
                });
            });
    }

}
